import dynamic from 'next/dynamic';
import { PrepayRatesProps } from './PrepayRates.types';

export const PrepayRatesMGP = dynamic<PrepayRatesProps>(() =>
  import('./PrepayRates').then(module => module.PrepayRates)
);
